module.exports = __webpack_public_path__ + "static/media/IMG_5667.95bef6b3.JPG";